export const tabHeight = '40px'
export const tabPanelHeight = `calc(100% - ${tabHeight})`